const CanapesIcon = () => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M1.9763 9.35248L8.95297 3.70498C9.24964 3.46494 9.61969 3.33398 10.0013 3.33398C10.3829 3.33398 10.753 3.46494 11.0496 3.70498L18.0255 9.35248M17.5013 12.5C17.7223 12.5 17.9343 12.5878 18.0906 12.7441C18.2468 12.9003 18.3346 13.1123 18.3346 13.3333V15C18.3346 15.221 18.2468 15.433 18.0906 15.5892C17.9343 15.7455 17.7223 15.8333 17.5013 15.8333H13.1263M2.5013 12.5C2.28029 12.5 2.06833 12.5878 1.91205 12.7441C1.75577 12.9003 1.66797 13.1123 1.66797 13.3333V15C1.66797 15.221 1.75577 15.433 1.91205 15.5892C2.06833 15.7455 2.28029 15.8333 2.5013 15.8333H10.0013"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.55859 12.5L10.6669 16.3333C10.842 16.4647 11.0413 16.5602 11.2533 16.6145C11.4653 16.6688 11.686 16.6809 11.9026 16.6499C12.1193 16.619 12.3278 16.5456 12.5161 16.4341C12.7044 16.3226 12.8689 16.1751 13.0003 16L15.6253 12.5"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.5013 9.1665H2.5013C2.04106 9.1665 1.66797 9.5396 1.66797 9.99984V11.6665C1.66797 12.1267 2.04106 12.4998 2.5013 12.4998H17.5013C17.9615 12.4998 18.3346 12.1267 18.3346 11.6665V9.99984C18.3346 9.5396 17.9615 9.1665 17.5013 9.1665Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default CanapesIcon;
